import { has, isString } from 'lodash'
import { Duration, DateTime } from 'luxon'

const youtubeHMS = duration => {
  const durationObject = duration.toObject()
  let format = 'mm:ss'

  if (has(durationObject, 'hours')) {
    format = `hh:${format}`
  }

  return duration.toFormat(format)
}

export const isoDurationToYoutubeFormat = durationISO => {
  if (isString(durationISO)) {
    const duration = Duration.fromISO(durationISO).minus(1, 'second')
    return youtubeHMS(duration)
  }
}

export const secondsToYoutubeFormat = seconds => {
  const duration = Duration.fromMillis(seconds * 1000)

  return youtubeHMS(duration)
}

export const formatViewDate = date => {
  const luxonDate = DateTime.fromISO(date)
  return `${luxonDate.toRelative()} at ${luxonDate.toFormat('HH:MM')}`
}
